// Service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', {scope: './'})
}

// Lazyload
import lazyloadPicture from './lazyload/picture.js'
import lazyloadIframe from './lazyload/iframe.js'

// Organism
import animateHero from './organism/hero.js'
import Swiper from './organism/swiper.js'

// Molecule
import animateElement from './molecule/animate.js'
import backToTop from './molecule/back-to-top.js'
import {toggleNavigation, scrollToHash} from './molecule/navigation-header.js'
import {showImprint, showPrivacy} from './molecule/navigation-footer.js'

// Atom
import {buttonClose} from './atom/atom.js'

// Scroll behavior polyfill for Safari
// http://iamdustan.com/smoothscroll/
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
